// 查询
export const PATH_SEARCH = '/search'
